<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='软著结算'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='450'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-text-field :rules="number" :disabled='item.step' label="结算数量" hide-details='auto' outlined v-model="form.settleNumber"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                  <v-select
                    :rules="required"
                    hide-details="auto"
                    outlined
                    :items="channelItems"
                    label="结算渠道"
                    v-model="form.channelId"
                    item-text='name'
                    item-value="id"
                  ></v-select>
                </v-col>
              </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea rows='4' label="备注信息" outlined v-model="form.remark"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { getByPid } from '@/api/system/dictionary.js'
  import { save } from '@/api/copyright/settle.js'

  export default {
    name: 'OrderSettle',
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
          step: false
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => (/^[0-99]*$/.test(value) && !!value && value <= this.maxSettleNumber) || `必填且为数字不得超过${this.maxSettleNumber}`,
        ],
        dataSelect: false,
        items: [],
        channelItems: [],
        form: {
          id: '',
          softwareId: '',
          orderId: '',
          remark: '',
          channelId: '',
          settleNumber: 1,
          settleTime: '',
          settleTimeStr: ''
        },
        defForm: {
          id: '',
          softwareId: '',
          orderId: '',
          remark: '',
          channelId: '',
          settleNumber: 1,
          settleTime: '',
          settleTimeStr: ''
        }
      }
    },
    methods: {
      save () {
        // this.form.settleTime = new Date(this.form.settleTimeStr).getTime() / 1000
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form.orderId = this.item.data.orderId || this.item.data.id
          this.form.softwareId = this.item.step ? this.item.data.id : ''
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      },
      getTypes () {
        getByPid(this.$constants.settleChannelPid).then(res => {
          if (res.status === 200) {
            this.channelItems = res.data
          }
        })
      }
    },
    created() {
      this.getTypes()
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      },
      maxSettleNumber () {
        if (this.item.step) {
          this.form.settleNumber = 1
          return 1
        } else {
          let number = 0
          this.item.data.orderSettleList.forEach(item => {
            number += item.settleNumber
          })
          return this.item.data.contract.productNumber - number
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
